define ['./reports.scss'], () ->
  ($state, RentappService, $timeout, $scope, $http, $stateParams, $sce, $uibModal, $q, ApplicationBundle, Landlord, Application, RENTAPPLICATION_API_URL, Flash, $window) ->
    $scope.profile = $stateParams.profile
    $scope.application = $stateParams.application
    $scope.card_type = require('./credit-card-icon.png')
    $scope.email_content = ''
    $scope.display_payment_option = false
    $scope.payment_option = null
    $scope.selected = {}
    $scope.total_price = 0
    $scope.report_source_profiles = $scope.landlord.report_source_profiles
    $scope.view_only =  $state.$current.name.indexOf("view_only") > 0
    $scope.data = {
      action: "",
      detail: ""
    }
    $scope.preapproval =
      confirm: false
      error: false
    
    $scope.sending = false
    $scope.error_message = ""

    $scope.reports = $scope.application.reports.map((report) ->
      report.source_identifier
    )

    $scope.report_criteria = ""
    $scope.detail_url = ""

    $scope.report_type = $scope.profile.short_label.toLowerCase()

    if $scope.profile.report and $scope.profile.report.compliance_requirements == 'preapproval'
      if $scope.profile.report.criteria.county
        $scope.report_criteria = "#{$scope.profile.report.criteria.county} County"
      
      if $scope.profile.report.criteria.city
        $scope.report_criteria = $scope.report_criteria + "#{if $scope.report_criteria.length > 0 then ", " else ""}#{$scope.profile.report.criteria.city}"
      
      if $scope.profile.report.criteria.state
        $scope.report_criteria = $scope.report_criteria + "#{if $scope.report_criteria.length > 0 then ", " else ""}#{$scope.profile.report.criteria.state}"

      $scope.detail_url = $scope.profile.report.compliance_detail_url
    
    $scope.missing_field_mapping = {
      "applicant__first_name": "Applicant First Name",
      "applicant__last_name": "Applicant Last Name",
      "current_employer__supervisor_name": "Supervisor Name",
      "current_employer__supervisor_phone": "Supervisor Phone #",
      "current_employer__organization_name": "Organization Name",
      "current_address__landlord_name": "Current Landlord Name",
      "current_address__landlord_phone": "Current Landlord Phone #",
      "previous_address_1__landlord_name": "Previous Landlord Name",
      "previous_address_1__landlord_phone": "Previous Landlord Phone #",
      "previous_address_2__landlord_name": "Previous Landlord Name",
      "previous_address_2__landlord_phone": "Previous Landlord Phone #",
      "current_employer__work_email": "Applicant Work Email"
    }

    # Toggle for a la carte report 
    $scope.is_async = $scope.profile.identifier.indexOf('landlord') >= 0 or $scope.profile.identifier.indexOf('employment') >= 0

    if !$scope.profile.show_new_card_dialog
      $scope.profile.card_to_use = 'saved'

      switch $scope.landlord.card_on_file.brand
        when 'Visa' then $scope.card_type = require('./../../../../directives/appCard/visa.png')
        when 'MasterCard' then $scope.card_type = require('./../../../../directives/appCard/mastercard.png')
        when 'Discover' then $scope.card_type = require('./../../../../directives/appCard/discover.png')
        when 'American Express' then $scope.card_type = require('./../../../../directives/appCard/amex.png')
        when 'JCB' then $scope.card_type = require('./../../../../directives/appCard/jcb.png')
        when 'Diners Club' then $scope.card_type = require('./../../../../directives/appCard/dinersclub.png')
        when 'Visa Electron' then $scope.card_type = require('./../../../../directives/appCard/visa-electron.png')
        when 'Maestro' then $scope.card_type = require('./../../../../directives/appCard/maestro.png')
        else $scope.card_type = require('./credit-card-icon.png')

    $scope.send_error_report = (profile, email_content) ->
      $scope.sending = true
      $http.post "#{RENTAPPLICATION_API_URL}#{profile.report.resource_uri}send_error_report/",
        email_content: email_content
      .then ->
        $scope.send_success = true
      .catch (r) ->
        Flash.create("danger", 'Unfortunately, an error has occured in processing this request. Please try again.')
        $window.scrollTo(0, 0);
      .finally () ->
        $scope.sending = false;
    
    $scope.open_opt_out_modal = () ->
      $uibModal.open
        scope: $scope
        template: require("./optOutModal.jade")
        controller: require("./optOutModal.coffee")
        windowClass: 'opt-out-modal'
      .result.then () ->
    
    $scope.fulfill_requirement = (profile, action) -> 
      $scope.data.action = action

      if action == 'preapproval' and !$scope.preapproval.confirm
        $scope.preapproval.error = true
        return 

      $scope.sending = true
      $http.post("#{RENTAPPLICATION_API_URL}#{profile.report.resource_uri}fulfill_requirements/", $scope.data)
      .then ->
        $window.location.reload()
      .catch (r) ->
        $scope.error_message = r.data.error or "Unfortunately, an error has occured in processing this request. Please try again."
      .finally () ->
        $scope.sending = false

    $scope.go_to_payment_option = (option) ->
      $scope.display_payment_option = true
      $scope.payment_option = option

    $scope.go_back_choose_payment_option = () ->
      $scope.display_payment_option = false
      $scope.payment_option = null

    $scope.go_to_verification = () ->
      $state.go 'root.verifications.disclaimer'

    $scope.select_rsp = (index) ->
      $scope.selected[index] = !$scope.selected[index]

      price = _.find($scope.report_source_profiles, (o) -> o.identifier == index).price

      if $scope.selected[index]
        $scope.total_price += price
      else
        $scope.total_price -= price

    $scope.request_applicant_payment = () ->
      $scope.loading = true
      identifiers = _.compact(_.map($scope.selected, (value, key) ->
        if value
          return key
      ))

      $http.post "#{RENTAPPLICATION_API_URL}#{$scope.application.resource_uri}request_applicant_payment/",
        'report_source_identifiers': identifiers
      .then () ->
        # Reloading page to update other tabs with new report data.
        $window.location.reload()
      .catch (err) ->
        console.log(err)
      .finally ->
        $scope.loading = false



// WEBPACK FOOTER //
// ./components/dashboard/view/reports/reports.coffee